import Redeem from './Redeem';

export default Redeem;
